import React, { FC } from 'react';
import CustomMultilineInput from '../../../common/CustomMultilineInput';
import useTranslation from '../../../hooks/useTranslation';
import CustomDateInput from '../../CustomDateInput';
import { ProjectStatusesFormProps } from './ProjectStatusesFormProps';
import StatusSelect from '../../StatusSelect';

const ProjectStatusesForm: FC<ProjectStatusesFormProps> = () => {
  const t = useTranslation();
  return (
    <>
      <StatusSelect value={'RETURNED'} />
      <CustomDateInput
        label={t('labels.projectStatusDate')}
        name={'projectStatusDate'}
        dataTestID={'project-status-date'}
        disabled={true}
      />
      <CustomMultilineInput
        name={'statusComments'}
        label={t('labels.countryProjectStatusComment')}
        dataTestID={'country-project-status-comment'}
      />
      <CustomMultilineInput
        name={'projectTimeStatusComment'}
        label={t('labels.projectTimeStatusComment')}
        dataTestID={'project-time-status-comment'}
      />
    </>
  );
};

export default ProjectStatusesForm;
